import Grid from '@mui/material/Grid2';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import AnalysisFilterViewModel from "../ViewModels/AnalysisFilterViewModel";

interface IProps {
    state: AnalysisFilterViewModel;
    updateState: (properties: Partial<AnalysisFilterViewModel>, callback?: (newState?: AnalysisFilterViewModel) => void) => Promise<void>;
}

export default function FlowDirection({ state, updateState }: IProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        var index = Number.parseInt((event.target as HTMLInputElement).value)

        updateState({
            direction: index,
        })
    }

    return (
        <Grid container component={Paper} size={12} padding={2}>
            <Typography>Direction of Flow</Typography>

            <Grid size={12}>
                <RadioGroup onChange={handleChange} value={state.direction}>
                    <FormControlLabel
                        key={2}
                        value={2}
                        control={<Radio />}
                        label={ "Arrivals and Departures" }
                    />
                    <FormControlLabel
                        key={0}
                        value={0}
                        control={<Radio />}
                        label={ "Arrivals" }
                    />
                    <FormControlLabel
                        key={1}
                        value={1}
                        control={<Radio />}
                        label={ "Departures" }
                    />
                </RadioGroup>
            </Grid>
        </Grid>
    )
}
